import React, { useState } from 'react';
import { useTheme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import useMediaQuery from '@mui/material/useMediaQuery';
import CardContent from '@mui/material/CardContent';
import Fab from '@mui/material/Fab';
import Grid from '@mui/material/Grid';
import { Button, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import Typography from '@mui/material/Typography';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import MuiDialogTitle from '@mui/material/DialogTitle';

import SearchIcon from '@mui/icons-material/Search';
import SearchActiveForm from '../SearchActiveForm';

import { blue } from '@mui/material/colors';

const useStyles = makeStyles((theme) => ({
	root: {
		backgroundColor: theme.palette.background.paper,
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center'
	},
	button: {
		flex: 1,
		color: blue[900],
		margin: 10,
		justifyContent: 'center',
		alignSelf: 'center'
	},
	backdrop: {
		zIndex: theme.zIndex.drawer + 1,
		color: '#fff'
	},
	closeButton: {
		position: 'absolute',
		right: theme.spacing(1),
		top: theme.spacing(1),
		color: theme.palette.grey[500]
	},
	content: {
		display: 'flex',
		padding: theme.spacing(0),
		overflowX: 'visible'
	},
	actions: {
		padding: theme.spacing(2, 4),
		backgroundColor: '#f8f8f8'
	}
}));

const DialogTitle = ({ children, onClose, ...other }) => {
	const classes = useStyles();
	return (
		<MuiDialogTitle disableTypography className={classes.root} {...other}>
			<Typography variant="h6">{children}</Typography>
			{onClose ? (
				<IconButton
					aria-label="close"
					className={classes.closeButton}
					onClick={onClose}
					size="large"
				>
					<CloseIcon />
				</IconButton>
			) : null}
		</MuiDialogTitle>
	);
};

export default function Search({ handleSearch, handleRefreshSearch, areaOptionsQuery }) {
	const [open, setOpen] = useState(false);
	const classes = useStyles();

	const handleClickOpen = () => {
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
	};

	const theme = useTheme();
	const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

	return (
		<React.Fragment>
			<CardContent className={classes.root}>
				<Grid container justifyContent="center" alignItems="center">
					<IconButton onClick={handleClickOpen} size="large">
						<Fab component="span" className={classes.button}>
							<SearchIcon />
						</Fab>
					</IconButton>
					<Dialog
						open={open}
						scroll="paper"
						onClose={handleClose}
						aria-labelledby="search"
						fullScreen={fullScreen}
					>
						<DialogTitle id="search" onClose={handleClose}>
							{'Filters'}
						</DialogTitle>
						<DialogContent dividers={true} className={classes.content}>
							<SearchActiveForm
								areaOptionsQuery={areaOptionsQuery}
								handleSearch={handleSearch}
								handleClose={handleClose}
								handleRefreshSearch={handleRefreshSearch}
							/>
						</DialogContent>
					</Dialog>
				</Grid>
			</CardContent>
		</React.Fragment>
	);
}
